import { SHARED_DIALOG_ACTION_TYPES } from '../../constants/sharedDialog.constants';

const initialState = { open: false, dialogs: [], savedCount: 0, savedResult: null };

export default function AttachmentDialogReducer(state = initialState, action) {
  switch (action.type) {
    case SHARED_DIALOG_ACTION_TYPES.SHOW_ATTACHMENT_DIALOG:
      return { ...state, open: true, dialogs: [...state.dialogs, action.payload] };

    case SHARED_DIALOG_ACTION_TYPES.HIDE_ATTACHMENT_DIALOG: {
      const top = state.dialogs[state.dialogs.length - 1];
      if (!top || (action.payload.requestId && action.payload.requestId !== top.requestId))
        return state;
      const dialogs = state.dialogs.slice(0, -1);
      return { ...state, dialogs, open: dialogs.length > 0 };
    }

    case SHARED_DIALOG_ACTION_TYPES.ATTACHMENT_DIALOG_SAVED:
      return { ...state, savedCount: state.savedCount + 1, savedResult: action.payload };

    default:
      return state;
  }
}
